import request from '@/src/apis/axios';
import NoticeDto from '@/src/models/NoticeDto';
import { ListResponse, ObjectResponse } from '@/src/types/common';
import { plainToInstance } from 'class-transformer';
import {
  GetNoticesRequestParams,
  GetNoticeByIdRequestParams,
  PostNoticeRequestBody,
  PutNoticeByIdRequestBody,
} from './notice.dtos';

const URL = {
  notice: '/admin/notices',
  noticeDetail: '/admin/notices/{id}',
};

// 공지사항 리스트 조회
export const getNoticesAPI = async (
  requestParams: Partial<GetNoticesRequestParams>,
) => {
  const { page = 1, pageSize = 10, ...rest } = requestParams;

  const { data } = await request<ListResponse<NoticeDto>>({
    method: 'get',
    url: URL.notice,
    queryParams: { ...rest, page, pageSize },
  });

  const rows = plainToInstance(NoticeDto, data.rows);

  return { rows, count: data.count };
};

// 공지사항 상세 조회
export const getNoticeByIdAPI = async (
  requestParams: GetNoticeByIdRequestParams,
) => {
  const { id } = requestParams;

  const { data } = await request<ObjectResponse<NoticeDto>>({
    method: 'get',
    url: URL.noticeDetail.replace('{id}', String(id)),
  });

  return plainToInstance(NoticeDto, data.row);
};

// 공지사항 생성
export const postNoticeAPI = async (requestBody: PostNoticeRequestBody) => {
  const { data } = await request<ObjectResponse<NoticeDto>>({
    method: 'post',
    url: URL.notice,
    requestBody: { ...requestBody, serviceType: 'EARTH_APP' },
  });

  return plainToInstance(NoticeDto, data.row);
};

// 공지사항 수정
export const putNoticeByIdAPI = async (
  requestBody: PutNoticeByIdRequestBody,
) => {
  const { id, ...rest } = requestBody;

  const { data } = await request<ObjectResponse<NoticeDto>>({
    method: 'put',
    url: URL.noticeDetail.replace('{id}', String(id)),
    requestBody: { ...rest, serviceType: 'EARTH_APP' },
  });

  return plainToInstance(NoticeDto, data.row);
};
